export default "__VITE_ASSET__b8be7264__"